/* eslint-disable import/no-relative-packages */

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ReactNode } from 'react';
import { ConfirmModalProvider } from '../src/app/modal/ConfirmModal/ConfirmModalProvider';

export function HermesContainer({ children }: { children: ReactNode }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ConfirmModalProvider>{children}</ConfirmModalProvider>
    </LocalizationProvider>
  );
}
